module.exports = __webpack_public_path__ + "static/mediscan-ebb8ff563ffd55239e6db1fe1294d22f.jpg";